import { defaultListData, defaultListState } from 'bv-data';
import type { ListModel, ListModelState } from '@/types';
import { getQuery } from 'bv-utils';
import { listService } from '@/services/accountProcess/fb';
import { putSave } from '@/models/utils';
import type { IAeTotalAccountInfo } from '@/services/accountProcess/fb/totalAccount';
import type { IAeReviewAccountInfo } from '@/services/accountProcess/fb/reviewAccount';

export type AccountProcessInfo = {} & IAeReviewAccountInfo & IAeTotalAccountInfo;

export type AccountProcessModelState = ListModelState<AccountProcessInfo>;
export type AccountProcessListModel = ListModel<AccountProcessModelState, 'process'>;

const listState: AccountProcessModelState = {
  ...defaultListState,
  id: 0,
  type: '',
  selectedRows: [],
  selectedRowKeys: [],
};

const ResearchModel: AccountProcessListModel = {
  namespace: 'process',
  state: listState,
  effects: {
    *list({ params }, { call, put, select }) {
      const pageType = params?.pageType;

      // handle history code
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const id: number = yield select((state: any) => state.process.id);
      const requestId = id + 1;
      yield put(putSave({ id: requestId, type: pageType, loading: true }));
      const [data, error] = yield call(listService[pageType], { ...getQuery(), ...params });
      // handle history code
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const currentId: number = yield select((state: any) => state.process.id);
      if (currentId === requestId) {
        yield put(putSave({ error, data: data ?? defaultListData, loading: false }));
      }
    },
    *select({ params = [] }, { put }) {
      yield put(
        // handle history code
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        putSave({ selectedRows: params, selectedRowKeys: params.map((item: any) => item.localId) }),
      );
    },
  },

  reducers: {
    clean(state) {
      return { ...state, ...defaultListState };
    },
    reset() {
      return listState;
    },
    save(state, { payload = {} }) {
      return { ...state, ...payload };
    },
  },
};

export default ResearchModel;
